module.exports = __webpack_public_path__ + "img/window-contact-lg-closed.75b1903e.svg";